import React from "react";

export function Logo() {
  return (
    <span>
      <b>
        WAVES
        <sup style={{ color: "blue" }}>◆</sup>
      </b>{" "}
      firewall
    </span>
  );
}

export default Logo;
